/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Token/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Token({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/TwoFactorAuth/Token",
  isInvalid,
  onChange,
  onSubmit
  
}) {
let resetPasswordConfirmMfaTokenValueData = fromData.useDataValue({ viewPath,
context: 'reset_password_confirm',
path: 'mfa.token',
})
let resetPasswordConfirmMfaTokenIsValidData = fromData.useDataIsValid({ viewPath,
context: 'reset_password_confirm',
path: 'mfa.token',
validate: fromValidate.sixDigits,
required: true,
})
let resetPasswordConfirmMfaTokenChangeData = fromData.useDataChange({ viewPath,
context: 'reset_password_confirm',
path: 'mfa.token',
})
let resetPasswordConfirmMfaTokenSubmitData = fromData.useDataSubmit({ viewPath,
context: 'reset_password_confirm',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 data="reset_password_confirm.mfa.token"
 validate="/Data/validate.js sixDigits"
 required={true}
 invalid={!resetPasswordConfirmMfaTokenIsValidData}
 value={resetPasswordConfirmMfaTokenValueData}
 onChange={resetPasswordConfirmMfaTokenChangeData}
 onSubmit={resetPasswordConfirmMfaTokenSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Two-factor authentication token"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 autoFocus={true}
 mask="sixDigits"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}